import { Divider } from '@material-ui/core'
import React from 'react'
import { useTranslation, WithTranslation } from 'react-i18next'
import { withRouter } from 'react-router'
import { InjectedFormProps } from 'redux-form'
import Flex from 'typescript-styled-flex'
import i18next from 'i18next'
import logoBedBooking from '../../assets/bb-logo-big.png'
import { Form, FormGroup, TextInput } from '../../components/FormBuilder'
import { is } from '../../components/MediaQuery'
import Button from '../../components/Template/Button'
import Card from '../../components/Template/Card'
import { CountryCode } from '../../i18n/countryCodes'
import mapCodeToRegisterLink from '../../i18n/mappers/mapCodeToRegisterLink'
import { IIsAuthorized } from '../../routes/withProtected/Protected'
import { ButtonLabel } from '../../components/Template/Premium'
import styled, { ITheme } from '../../theme'
import { useMixpanelTrackView } from '../../hooks/useMixpanelTrackView'

const Header = styled.div`
  border-bottom: 1px solid #009139;
  padding-bottom: 10px;
  max-width: 300px;
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 18px;
`

const SubHeader = styled.div`
  color: ${({ theme }: ITheme) => theme.colors.palette.slateGrey};
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
`

const HelpMessage = styled.div`
  color: ${({ theme }: ITheme) => theme.colors.palette.slateGrey};
  font-size: 13px;

  & > div {
    margin-bottom: 20px;
  }
`

const StyledLink = styled.a`
  color: #009139;
  cursor: pointer;
`

function PasswordReset({
  handleSubmit,
  submitting,
}: InjectedFormProps & IIsAuthorized & WithTranslation & any) {
  const isDesktop = is.desktop()
  useMixpanelTrackView('Password Recovery Screen View')

  const { t } = useTranslation()
  const lang = i18next.language ? i18next.language : 'en'

  const mapToLink = code => {
    switch (code) {
      case 'pl':
        return 'https://support.bed-booking.com/hc/pl/sections/360003731551-PROBLEMY-Z-LOGOWANIEM'
      case 'pl_PL':
        return 'https://support.bed-booking.com/hc/pl/sections/360003731551-PROBLEMY-Z-LOGOWANIEM'
      case 'it':
        return 'https://support.bed-booking.com/hc/it/sections/360003731551-PROBLEMI-CON-L-ACCESSO'
      case 'es':
        return 'https://support.bed-booking.com/hc/es-es/sections/360003731551-PROBLEMAS-DE-INICIO-DE-SESI%C3%93N'
      default:
        return 'https://support.bed-booking.com/hc/en-us/sections/360003731551-PROBLEMS-WITH-LOGGING-IN'
    }
  }

  const mapToLinkContact = code => {
    switch (code) {
      case 'pl':
        return 'https://support.bed-booking.com/hc/pl/requests/new'
      case 'pl_PL':
        return 'https://support.bed-booking.com/hc/pl/requests/new'
      case 'it':
        return 'https://support.bed-booking.com/hc/it/requests/new'
      case 'es':
        return 'https://support.bed-booking.com/hc/es-es/requests/new'
      default:
        return 'https://support.bed-booking.com/hc/en-us/requests/new'
    }
  }

  return (
    <div>
      <Flex
        full={true}
        center={true}
        style={{ paddingTop: '50px', paddingBottom: '50px' }}
      >
        <Card withBackgroundColor={'#FFF'} withShadow={true}>
          <Flex center={true} style={{ padding: '10px 0px 20px' }}>
            <img
              style={{ width: '350px' }}
              alt={'BedBooking'}
              src={logoBedBooking}
            />
          </Flex>
          <Divider />
          <Flex style={{ padding: '20px' }} full={true}>
            <Form onSubmit={handleSubmit} style={{ height: '100%' }}>
              <FormGroup.Nested column={true}>{/*form*/}</FormGroup.Nested>
              <Header>{t('BBO_3914_password_recovery')}</Header>
              <SubHeader>
                {t('BBO_3914_password_recovery_text_follow_instructions')}
              </SubHeader>
              <HelpMessage>
                <div>{t('BBO_3914_password_recovery_text_1')}</div>
                <div>{t('BBO_3914_password_recovery_text_2')}</div>
                <div>{t('BBO_3914_password_recovery_text_3')}</div>
                <div>
                  {t('BBO_3914_password_recovery_text_footer')}{' '}
                  <StyledLink href={mapToLinkContact(lang)} target={'_blank'}>
                    {t('BBO_3914_contact_us')}
                  </StyledLink>
                </div>
              </HelpMessage>
              <TextInput.ReduxField
                name={'email'}
                autocomplete={'email'}
                type={'email'}
                placeholder={t('startup_login_hint')}
                width={'100%'}
                wrapperStyle={{
                  height: '42px',
                  maxHeight: '42px',
                  minHeight: '42px',
                }}
              />
              <Button
                as={'button'}
                disabled={submitting}
                type={'submit'}
                primary={true}
                style={{ height: '45px', marginTop: '20px', minHeight: '45px' }}
              >
                <ButtonLabel style={{ color: 'white', fontSize: '1em' }}>
                  {t('send')}
                </ButtonLabel>
              </Button>
              <Button
                as={'a'}
                href={mapToLink(lang)}
                target={'_blank'}
                type={'button'}
                style={{ height: '45px', marginTop: '5px', minHeight: '45px' }}
              >
                <ButtonLabel style={{ fontSize: '1em' }}>
                  {t('widget_info_4_help')}
                </ButtonLabel>
              </Button>
            </Form>
          </Flex>
          <Flex
            row={isDesktop}
            column={!isDesktop}
            full={true}
            justifyBetween={true}
            style={{ borderTop: '1px solid #ddd', padding: '20px' }}
          >
            <Button
              href={'/login'}
              style={{ marginBottom: isDesktop ? '0px' : '10px' }}
            >
              {t('startup_login_btn')}
            </Button>
            <Button href={mapCodeToRegisterLink(lang as CountryCode)}>
              {t('registration_create')}
            </Button>
          </Flex>
        </Card>
      </Flex>
    </div>
  )
}

export default withRouter(PasswordReset)
